import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", to: "/" },
  { label: "Collections", to: "/collections" },
  { label: "About", to: "/#about" },
  { label: "Contact", to: "/#contact" },
];

export const Header = ({ settings }) => {
  const [open, setOpen] = useState(false);
  const brand = settings?.brand_name || "Trendy threads by Vee";
  const wa = settings?.whatsapp_number;

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0A0A0B]/60 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex flex-col leading-none">
          <span className="font-heading text-2xl sm:text-[26px] text-ink tracking-tight">
            {brand}
          </span>
          <span className="font-accent text-[10px] tracking-[0.35em] uppercase text-champagne mt-0.5">
            {settings?.tagline || "VeeVee's"}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-accent text-xs tracking-[0.2em] uppercase text-ash hover:text-champagne transition-colors duration-300"
            >
              {l.label}
            </Link>
          ))}
          {wa && (
            <a
              href={`https://wa.me/${wa}`}
              target="_blank"
              rel="noreferrer"
              data-testid="header-whatsapp-cta"
              className="font-accent text-xs tracking-[0.2em] uppercase border border-champagne/60 text-champagne px-5 py-2.5 hover:bg-champagne hover:text-obsidian transition-all duration-300"
            >
              Enquire
            </a>
          )}
        </nav>

        <button
          className="md:hidden text-ink"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0A0A0B]/95 px-5 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="font-accent text-sm tracking-[0.2em] uppercase text-ash hover:text-champagne"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
